import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import DiscountsList from '../DiscountsList';

export interface ProductDiscountsProps {
  name: string;
  finalPrice: string;
  initialPrice: string;
  discounts: {
    vipCodeSavings: string;
    tieredSaving: string;
  };
  tieredSavingEndDate?: string;
  vat: ReactNode;
}

export default function ProductDiscounts(props: ProductDiscountsProps) {
  const {
    name,
    finalPrice,
    initialPrice,
    discounts,
    tieredSavingEndDate,
    vat,
  } = props;
  const { t } = useTranslation();

  const discountsList = [
    {
      name: name,
      price: initialPrice,
    },
    {
      name: t('site.pricing.products-selection.price-info.tiered-saving.label'),
      subName:
        tieredSavingEndDate &&
        t(
          'site.pricing.products-selection.price-info.tiered-saving.description',
          {
            0: tieredSavingEndDate,
          },
        ),
      price: `-${discounts.tieredSaving}`,
    },
    {
      name: t(
        'site.pricing.products-selection.price-info.vip-code-saving.label',
      ),
      price: `-${discounts.vipCodeSavings}`,
    },
  ];

  return (
    <DiscountsList totalPrice={finalPrice} list={discountsList} vat={vat} />
  );
}
